module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "also-read-wrapper"
  }, [_c('div', {
    class: ("also-read-article-wrapper " + (_vm.article.isLast ? 'last': ''))
  }, [_c('span', {
    staticClass: "also-read-tag"
  }, [_vm._v("also read")]), _c('div', {
    staticClass: "also-read-content"
  }, [_c('a', {
    staticClass: "also-read-content-title",
    attrs: {
      "href": _vm.node.relative_url
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02cc2cc0","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/amp/AmpAlsoRead.vue
// module id = 1724
// module chunks = 39